<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-flash-ad-config-table ref="table" :items.sync="_items" :toolbar="false" :title="title"/>
  </r-panel>
</template>
<script>

import VueTypes from "vue-types";
import {FlashAdConfig} from "@/modules/redactor/models/smart-offer/bundle-flash-ad/FlashAdConfig";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RFlashAdConfigTable from "@/modules/redactor/views/smart-offer/bundle-flash-ad/r-flash-ad-config-table.vue";

export default {
  name: "r-flash-ad-config-panel",
  components: {RFlashAdConfigTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Configs"),
    items: VueTypes.arrayOf(FlashAdConfig)
  },
  computed: {
    _items() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>